import React from 'react';
import { motion } from 'framer-motion';
import { whatsappLink } from '../lib/whatsapp';
import { useLanguage } from '../lib/i18n';
export function MiddleText() {
  const {
    t,
    lang
  } = useLanguage();
  return <section className="py-20 sm:py-32 lg:py-48 text-center px-5 sm:px-8 bg-ivory border-y border-beige w-full overflow-hidden" data-id="element-223">
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] lg:text-xs font-semibold mb-6 sm:mb-10" data-id="element-224">
        {t('middle.tag')}
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.4,
      delay: 0.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="font-display text-fluid-h2 text-volcanic font-light mb-10 sm:mb-16 leading-[1.1]" data-id="element-225">
        {t('middle.title1')}{' '}
        <span className="font-script text-fluid-script text-terracotta italic inline-block mt-[-0.1em]" data-id="element-226">
          {t('middle.title2')}
        </span>
      </motion.h2>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2,
      delay: 0.5
    }} className="flex justify-center gap-3 sm:gap-4 mb-10 sm:mb-16" data-id="element-227">
        {Array.from({
        length: 3
      }).map((_, i) => <motion.span key={i} initial={{
        scale: 0
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6 + i * 0.2,
        ease: 'easeOut'
      }} className="w-1.5 h-1.5 rounded-full bg-terracotta/60" data-id="element-228" />)}
      </motion.div>

      <motion.a initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      delay: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }} href={whatsappLink('middle', lang)} target="_blank" rel="noopener noreferrer" className="inline-block bg-terracotta hover:bg-terracottaDark text-ivory px-10 sm:px-14 py-4 sm:py-5 rounded-md uppercase tracking-[0.2em] text-[10px] sm:text-xs transition-colors duration-300 w-full sm:w-auto" data-id="element-229">
        {t('middle.btn')}
      </motion.a>
    </section>;
}